
 <div class="chat-container">
  <app-message-list [messages]="messages"></app-message-list>
  
  <app-message-form [message]="message" [messages]="messages" [agenteAssigned]="agenteAssigned"
  [participantID]="participantID" [agentTyping]="agentTyping" [agentesDisponibles]="agentesDisponibles" 
  (procesarRespuesta)="procesarRespuesta($event)" [mensajesGuardados]="mensajesGuardados" [positionQueue]="positionQueue"
  [ctx]="ctx" [cambioDeServicio]="cambioDeServicio" [fueraHorario]="fueraHorario" [habilitado]="habilitado" (iniciarChat)="iniciarChat()"
  (switchHandlerEmitter)="emitSwitchHandlerEmitter($event)"
  ></app-message-form>
 </div>
